import CircularProgress from "@mui/material/CircularProgress";

export default function Loading() {
  return (
    <div style={{
      width: "90%",
      height: "100%",
      position: "absolute",
      top: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "none",
    }}>
      <CircularProgress sx={{ color: "var(--cor-roxoEscuro)" }} />
    </div>
  );
}
